import { createI18n } from 'vue-i18n'
import en from "./locales/en"
import zh from "./locales/zh"
import es from "./locales/es"
const messages = {
    en,
    zh,
    es
}
const savedLang = localStorage.getItem('lang') || 'en'


export default createI18n({
    legacy: false, 
    locale: savedLang, 
    messages
})